import React, { useState } from "react";
import { searchData } from "./searchData";
import "./autosuggest.css";
import IntroVideoModal from '../about/IntroVideoModal';
import EducationPopUp from "../qualification/EducationPopUp";

const AutoSuggestSearch = () => {
    const [query, setQuery] = useState("");

    const filtered =
        query?.length > 0
            ? searchData?.filter((item) =>
                item?.name?.toLowerCase()?.includes(query.toLowerCase())
            )
            : [];

    const [selectedItem, setSelectedItem] = useState(null);
    const [open, setOpen] = useState(false);

    return (
        <div className="search-container">

            <div className="search-input-wrapper">
                <input
                    type="text"
                    placeholder="🔍 Search skills, projects, certificates..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                />
            </div>

            {filtered.length > 0 && (
                <div className="search-dropdown">

                    {filtered.map((item) => (
                        <div className="search-item" key={item.id} onClick={() => setSelectedItem(item)}>
                            <div className="left">
                                <span className="icon">{item.icon}</span>
                                <div>
                                    <div className="name">{item.name}</div>
                                    <div className="type">{item.type}</div>
                                </div>
                            </div>
                        </div>
                    ))}

                </div>
            )}

            {selectedItem && (
                <div className="popup-overlay" onClick={() => setSelectedItem(null)}>
                    <div
                        className="popup-content popup-animate"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className="popup-close"
                            onClick={() => setSelectedItem(null)}
                        >
                            ✖
                        </button>

                        <h2>
                            {selectedItem.icon} {selectedItem.name}
                        </h2>

                        <div className="popup-type">{selectedItem.type}</div>
                        {selectedItem.description && (
                            <pre className="popup-description">
                                {selectedItem.description || "Details coming soon..."}
                            </pre>
                        )}

                        {selectedItem.link && (<a
                            href={selectedItem.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="resume-btn"
                        >
                            📄 { }{selectedItem.textOnLink || "View Details"}
                        </a>)}

                        {selectedItem?.item && (
                            <>
                                <div className='project__modal-headings'><br />
                                    <h3>🎓 Basic Institute Info :</h3>
                                    <p><b>Institute / University name :</b> {selectedItem?.item?.subTitle}</p>
                                    <p><b>Location (City, State, Country) :</b> {selectedItem?.item?.location}</p>
                                </div>

                                <div className='project__modal-headings'>
                                    <h3>📘 Education Details :</h3>
                                    <p><b>Degree / Course Name :</b> {selectedItem?.item?.title}</p>
                                    <p><b>Specialization / Major / Minor subjects :</b> {selectedItem?.item?.specialization}</p>
                                    <p><b>Duration (Start Year – End Year) :</b> {selectedItem?.item?.duration}</p>
                                    <p><b>Mode of Study :</b> {selectedItem?.item?.modeOfStudy}</p>
                                </div>

                                <div className='project__modal-headings'>
                                    <h3>🔗 Extra Elements</h3>
                                    <p><b>Key Skills Learned :</b> {selectedItem?.item?.skills}</p>
                                    <p><b>Certificates earned :</b> {selectedItem?.item?.certificates}</p>
                                    <p><b>Internships or Training programs :</b> {selectedItem?.item?.internshipsOrTraining}</p>
                                </div>
                            </>
                        )}

                        {selectedItem.introVideo && <IntroVideoModal isOpen={open} onClose={() => setOpen(false)} />}

                    </div>
                </div>
            )}

        </div>
    );
};

export default AutoSuggestSearch;